export default api => ({
  includeInReport: (transactionId, transactionUrl) => api.post(`/testing-tool/include-in-report/${transactionId}/${transactionUrl}`)
})
